/* Mobile drawer: a top-level item that has a submenu (FEATURED, COLLECTIONS) is
   a dropdown trigger, not a link — its href is just a placeholder collection.
   On desktop these are non-clickable; mirror that on mobile so tapping the row
   EXPANDS the submenu (accordion) instead of navigating to that collection.
   Items without a submenu (OUR STORY) keep navigating normally. */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest('.m-menu-mobile__link');
      if (!link) return;
      var item = link.parentElement;
      if (!item) return;
      // A submenu toggle button as a direct child means this item has children.
      var toggle = item.querySelector(':scope > .m-menu-mobile__toggle-button');
      if (!toggle) return;
      e.preventDefault();
      toggle.click();
    },
    true
  );
})();
